var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgYes(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "10px",
    height: "8px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "rgb(19, 194, 194)",
    d: "M9.830,1.280 C9.830,1.431 9.767,1.576 9.655,1.682 L4.225,6.872 C4.044,7.044 3.858,7.271 3.561,6.988 L0.753,4.236 C0.522,4.023 0.497,3.678 0.697,3.438 C0.911,3.201 1.285,3.176 1.533,3.380 C1.544,3.390 1.554,3.399 1.565,3.409 L3.801,5.547 C3.838,5.583 3.898,5.584 3.935,5.549 C3.936,5.548 3.937,5.547 3.938,5.547 L8.838,0.861 C8.972,0.726 9.173,0.672 9.362,0.720 C9.633,0.783 9.826,1.013 9.830,1.280 Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYes);
export default __webpack_public_path__ + "static/media/yes.c8e38c61ef333c339f2dc4cf1aa00fe1.svg";
export { ForwardRef as ReactComponent };